module.exports = "/img/5.0c314b.jpg";